import React from 'react';
import { useTranslation } from './i18n';

export default function AIpolicyPage({ onBack }) {
  const { t } = useTranslation();

  const sections = [
    {
      title: t('ai_policy_page.sections.applicability.title'),
      body: [t('ai_policy_page.sections.applicability.body')],
    },
    {
      title: t('ai_policy_page.sections.use_cases.title'),
      body: [t('ai_policy_page.sections.use_cases.intro')],
      bullets: [
        t('ai_policy_page.sections.use_cases.item_1'),
        t('ai_policy_page.sections.use_cases.item_2'),
        t('ai_policy_page.sections.use_cases.item_3'),
        t('ai_policy_page.sections.use_cases.item_4'),
      ],
    },
    {
      title: t('ai_policy_page.sections.supportive.title'),
      bullets: [
        t('ai_policy_page.sections.supportive.item_1'),
        t('ai_policy_page.sections.supportive.item_2'),
        t('ai_policy_page.sections.supportive.item_3'),
      ],
    },
    {
      title: t('ai_policy_page.sections.no_guarantee.title'),
      body: [t('ai_policy_page.sections.no_guarantee.intro'), t('ai_policy_page.sections.no_guarantee.outro')],
      bullets: [
        t('ai_policy_page.sections.no_guarantee.item_1'),
        t('ai_policy_page.sections.no_guarantee.item_2'),
        t('ai_policy_page.sections.no_guarantee.item_3'),
      ],
    },
    {
      title: t('ai_policy_page.sections.transparency.title'),
      bullets: [
        t('ai_policy_page.sections.transparency.item_1'),
        t('ai_policy_page.sections.transparency.item_2'),
        t('ai_policy_page.sections.transparency.item_3'),
      ],
    },
    {
      title: t('ai_policy_page.sections.fairness.title'),
      bullets: [
        t('ai_policy_page.sections.fairness.item_1'),
        t('ai_policy_page.sections.fairness.item_2'),
        t('ai_policy_page.sections.fairness.item_3'),
      ],
    },
    {
      title: t('ai_policy_page.sections.responsible_use.title'),
      body: [t('ai_policy_page.sections.responsible_use.intro')],
      bullets: [
        t('ai_policy_page.sections.responsible_use.item_1'),
        t('ai_policy_page.sections.responsible_use.item_2'),
        t('ai_policy_page.sections.responsible_use.item_3'),
      ],
    },
    {
      title: t('ai_policy_page.sections.data_use.title'),
      bullets: [
        t('ai_policy_page.sections.data_use.item_1'),
        t('ai_policy_page.sections.data_use.item_2'),
        t('ai_policy_page.sections.data_use.item_3'),
      ],
    },
    {
      title: t('ai_policy_page.sections.limitations.title'),
      body: [t('ai_policy_page.sections.limitations.intro')],
      bullets: [
        t('ai_policy_page.sections.limitations.item_1'),
        t('ai_policy_page.sections.limitations.item_2'),
        t('ai_policy_page.sections.limitations.item_3'),
      ],
    },
    {
      title: t('ai_policy_page.sections.liability.title'),
      bullets: [
        t('ai_policy_page.sections.liability.item_1'),
        t('ai_policy_page.sections.liability.item_2'),
      ],
    },
    {
      title: t('ai_policy_page.sections.development.title'),
      body: [t('ai_policy_page.sections.development.body')],
    },
    {
      title: t('ai_policy_page.sections.governing_law.title'),
      body: [t('ai_policy_page.sections.governing_law.body')],
    },
    {
      title: t('ai_policy_page.sections.final_clause.title'),
      body: [t('ai_policy_page.sections.final_clause.body')],
    },
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white shadow-sm">
        <div className="max-w-4xl mx-auto px-6 py-4 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <img src="/logozondertekst.png" alt="Logo" className="h-8" />
            <span className="font-bold text-gray-900">WeRepresent</span>
          </div>
          <button
            onClick={onBack}
            className="text-gray-600 hover:text-gray-900 transition-colors"
          >
            {t('ai_policy_page.back_home')}
          </button>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-6 py-12">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">{t('ai_policy_page.title')}</h1>
        <p className="text-gray-500 mb-8">{t('ai_policy_page.subtitle')}</p>
        
        <div className="bg-white rounded-xl shadow-sm p-8 space-y-6 text-gray-700">
          {sections.map((section) => (
            <section key={section.title}>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">{section.title}</h2>
              {section.body?.map((paragraph) => (
                <p key={paragraph} className="mt-3 first:mt-0">{paragraph}</p>
              ))}
              {section.bullets?.length ? (
                <ul className="ml-4 list-disc space-y-1 mt-2">
                  {section.bullets.map((bullet) => (
                    <li key={bullet}>{bullet}</li>
                  ))}
                </ul>
              ) : null}
            </section>
          ))}

        </div>
      </main>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-8 mt-12">
        <div className="max-w-4xl mx-auto px-6 text-center text-gray-400 text-sm">
          {t('ai_policy_page.footer', { year: new Date().getFullYear() })}
        </div>
      </footer>
    </div>
  );
}
